// src/plugins/apiPlugin.js
import api from '../api/apiService';

export default {
  install(Vue) {
    Vue.prototype.$api = api;
  }
};
